export class ExtendedControlsPrefix
{
    BORDER_RADIUS = 'border-radius';
    PROPERTY_BORDER = 'border';

    constructor(property, top, right, bottom, left) {
        this._updatedProperty = this.getUpdatedPropertyForExtendedControls(property);
        this._top = top;
        this._right = right;
        this._bottom = bottom;
        this._left = left;
    }

    get updatedProperty() {
        return this._updatedProperty;
    }

    get top() {
        return this._top;
    }

    get right() {
        return this._right;
    }

    get bottom() {
        return this._bottom;
    }

    get left() {
        return this._left;
    }

    getPrefixedTopProperty()
    {
        return this.updatedProperty + this.top;
    }

    getPrefixedBottomProperty()
    {
        return this.updatedProperty + this.bottom;
    }

    getPrefixedRightProperty()
    {
        return this.updatedProperty + this.right;
    }

    getPrefixedLeftProperty()
    {
        return this.updatedProperty + this.left;
    }

    getUpdatedPropertyForExtendedControls(property) {
        if (property === this.BORDER_RADIUS) {
            return this.PROPERTY_BORDER;
        }

        return property
    }
}